module.exports = __webpack_public_path__ + "img/header_1.41b5295b.jpg";